import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  CheckoutTermsCheckbox,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const losangelesangels_upgrades: TTeamConfig = {
  TEAM_SCHEMA: "losangelesangels_upgrades",
  TEAM_FULL_NAME: "Los Angeles Angels",
  BROWSER_TITLE: "Los Angeles Angels Upgrades",
  CLIENT_ID: "RiOllv9Wd5OzMJk7GyrrhOUllSYOkTIF1gd7nrH9Zm7F9auv",
  VENDOR: constants.vendorUUIDs.ticketsdotcom,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#BA0021",
    COLORS_SECONDARY: "#000000",
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,
    IS_BALLPARK_APP: true,

    NAV_MENU: {
      HIDE_AUTH_BUTTONS: true,
      HIDE_EARN_REWARDS: true,
      HIDE_UPCOMING_EVENTS: true,
      LOGIN_LABEL: "View Upgrades",
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },

    ACCOUNT_MANAGER_URL:
      "https://mlb.tickets.com/?orgid=52470&agency=ANGM_MYTIXX&tfl=Los_Angeles_Angels-Tickets-Manage_Your_Tickets-button-x0-Desktop-Landscape&adobe_mc=MCMID=14093986887918835934395933928119221636|MCORGID=A65F776A5245B01B0A490D44%40AdobeOrg|TS=1770660404&_gl=1*3kyb14*_ga*NDg0NDg5NTAwLjE3NzA2NTg3OTk.*_ga_N8YFCZLYSZ*czE3NzA2NTg3OTgkbzEkZzEkdDE3NzA2NjA0MDUkajYwJGwwJGg4ODkzNDcwODM.*_fplc*ZlBhakJ0RDREdUVBMm92bDMzWklOZEtHNFhvekZLJTJCbjR3JTJGUiUyQm5NdjJ3ZkF2aVFmOVZsWFZocXNsTlRoVWg3N2VuSTFMTTlEUlAweG85QkJHTjdNbGNpbXNPcWJmQTBDZFJxaFhpU290TlVOJTJGOUYlMkJEVTdaYlhZZHQxT01MUSUzRCUzRA..*_gcl_au*MTQxMjc5MzYwMi4xNzcwNjU4Nzk5",

    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,

    FOOTER: {
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()} MLB Advanced Media, L.P. All rights reserved`,
    },
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      HIDE_SECTION_TITLE: true,
      REGISTRATION_CARDS,
    },

    HIDE_PASSES: true,
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      MAX_HEIGHT: "320px",
    },
  },

  HOME_PAGE_SETTINGS: {
    IS_QUICK_CHECKOUT_ENABLED: true,
    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
      HIDE_NEXT_GAME: true,
      HIDE_EVENT_LOGO: true,
    },

    ADD_ON: {
      ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
        TITLE: () => "Purchase Confirmed!",
        DESCRIPTION: () => (
          <>
            Thank you for your purchase, your tickets are now available in the
            Ballpark App Wallet. Please remember your Upgrade ticket cannot be
            used for entry into the venue.
          </>
        ),
      },
      ADD_SERVICE_FEE_TO_PRICE: true,
      HIDE_MAX_COUNT_LABEL: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
      CHECKOUT_TERMS_CHECKBOX: <CheckoutTermsCheckbox />,
    },

    ADD_ONS_LABEL: "Upgrade Tickets",
    SERVICE_FEE_LABEL: "Total Per Ticket Fee(s)",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  AUTH_PAGE_SETTINGS: {
    HIDE_ACCOUNT_DETAILS: true,
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/los-angeles-angels-of-anaheim.png",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Los%20Angeles%20Angels/los-angeles-angels-banner.png",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Los%20Angeles%20Angels/StadiumNight_Resize_375x550.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Los%20Angeles%20Angels/Pass%20Assets/Background_Image_1920x1080_A.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
